{
    "title": "JSON schema for KLPMS config file",
    "$schema": "https://degeetia.ee/schema/klpms/config",

    "type": "object",
    "properties": {
        "conf_type": {
            "type": "string",
            "title": "Configuration type",
            "description": "Configuration type",
            "default": "global",
            "enum": ["global", "estonia", "finland", "poland"]
        },
        "debug": {
            "type": "boolean",
            "title": "Debug mode",
            "description": "Debug mode. NB! Turns off automatic wagon info update, click to current time for manual update",
            "default": false
        },
        "dir_app": {
            "type": "string",
            "title": "App base directory",
            "description": "Base directory for KLPMS Web and Service application components. Automatically assigned by components themselves, values from the configuration files will be overwritten",
            "readOnly": true
        },
        "dir_base": {
            "type": "string",
            "title": "KLPMS base directory",
            "description": "Base directory for KLPMS, relative to the {dir_app} directory",
            "default": ".."
        },
        "dir_conf": {
            "type": "string",
            "title": "Base directory for config",
            "description": "Base directory for KLPMS configuration files, relative to the {dir_base} directory",
            "default": "conf"
        },
        "dir_data": {
            "type": "string",
            "title": "Base directory for data",
            "description": "Base directory for KLPMS data files, relative to the {dir_base} directory",
            "default": "data"
        },
        "dir_schema": {
            "type": "string",
            "title": "Schema files directory",
            "description": "Schema files directory",
            "default": "schema"
        },
        "dir_products": {
            "type": "string",
            "title": "Product files directory",
            "description": "Product files directory",
            "default": "products"
        },
        "dir_measurements": {
            "type": "string",
            "title": "Measurement files directory",
            "description": "Directory, where to put measurement files",
            "default": "measurements"
        },
        "dir_nominalGraphs": {
            "type": "string",
            "title": "Nominal graph files directory",
            "description": "Directory for storing nominal graph files",
            "default": "nominalGraphs"
        },
        "max_records": {
            "type": "integer",
            "title": "Max records in archive search",
            "description": "Maximum number of records in archive search results",
            "default": 1200
        },
        "user_password": {
            "type": "string",
            "title": "User password",
            "description": "Password for web environment (use username 'user')",
            "default": "1234"
        },
        "password": {
            "type": "string",
            "title": "Archive password",
            "description": "Password for archive page (use username 'archive')",
            "default": "1234"
        },
        "session_file": {
            "type": "string",
            "title": "Session file",
            "description": "Session file location",
            "default": "sessions.json"
        },
        "session_expiry": {
            "type": "integer",
            "title": "Session expiry time",
            "description": "Session expiry time in seconds (default 7 days)",
            "default": 604800
        },
        "conf_wagons": {
            "type": "string",
            "title": "Wagons config file",
            "description": "Wagon configuration file location",
            "default": "wagons.json"
        },
        "conf_settings": {
            "type": "string",
            "title": "Settings file",
            "description": "Settings configuration file location",
            "default": "settings.json"
        },
        "loading_wagon": {
            "type": "string",
            "title": "Loading wagon file",
            "description": "Currently loading wagon file",
            "default": "loading.json"
        },
        "ads_net_id": {
            "type": "string",
            "title": "ADS network ID",
            "description": "ADS network ID of PLC controller. Default is \"\", i.e. PLC resides on the same machine",
            "default": ""
        },
        "ads_port": {
            "type": "integer",
            "title": "ADS port",
            "description": "ADS port for PLC controller. Default is 851",
            "default": 851
        },
        "plc_cycle_time": {
            "type": "integer",
            "title": "PLC cycle time",
            "description": "PLC cycle time (wait time) in ms used by TwinCAT API for checking PLC variables",
            "default": 100
        },
        "poll_cycle_time": {
            "type": "integer",
            "title": "Polling cycle time",
            "description": "Polling cycle time (wait time) in ms, before checking again PLC flag variable values",
            "default": 100
        },
        "error_log": {
            "type": "string",
            "title": "PLC error file",
            "description": "PLC error log location",
            "default": "error.log"
        },
        "error_log_lines": {
            "type": "integer",
            "title": "Max PLC error count",
            "description": "PLC error log lines",
            "default": 100
        },
        "logfile_web": {
            "type": "string",
            "title": "Web log file",
            "description": "KLPMS Web component log file",
            "default": "web.log"
        },
        "logfile_service": {
            "type": "string",
            "title": "Service log file",
            "description": "KLPMS Service component log file",
            "default": "service.log"
        },
        "log_level": {
            "type": "string",
            "title": "Log level",
            "description": "Logging level for KLPMS Web and Service components",
            "default": "info",
            "enum": ["trace", "debug", "info", "warn", "error", "fatal", "none"]
        },
        "csv_number_format": {
            "type": "string",
            "title": "CSV locale",
            "description": "Locale used for CSV number formatting",
            "default": "et-EE"

        },
        "csv_encoding": {
            "type": "integer",
            "title": "CSV codepage",
            "description": "Windows codepage used for CSV file encoding",
            "default": 1257
        },
        "save_raw_measurements": {
            "type": "boolean",
            "title": "Save raw measurements",
            "description": "Save raw measurements into database",
            "default": true
        },
        "wagon_count": {
            "type": "integer",
            "title": "Wagons count",
            "description": "Wagons count (22/24/30/34), default 34",
            "enum": [
                22,
                24,
                30,
                34
            ],
            "default": 34
        },
        "wagon_offset_loading": {
            "type": "integer",
            "title": "Wagon offset loading",
            "description": "Offset of the number of the wagon in loading with respect to the active wagon",
            "default": -3
        },
        "wagon_offset_bending": {
            "type": "integer",
            "title": "Wagon offset bending",
            "description": "Offset of the number of the wagon in bending with respect to the active wagon",
            "default": 14
        },
        "measurement_line_count": {
            "type": "integer",
            "title": "Measurement lines count",
            "description": "Measurement lines count (3/5), default 3",
            "enum": [
                3,
                5
            ],
            "default": 3
        },
        "simple_ui": {
            "type": "boolean",
            "title": "Simple UI",
            "description": "Show simplified UI without some fields",
            "default": false
        },
        "glass_file_type": {
            "type": "string",
            "title": "Allowed glass file types",
            "description": "Allowed glass file types, separated by comma. Supported types: \"dat\", \"ncp\"",
            "default": "dat,ncp"
        },
        "no_wagons": {
            "type": "boolean",
            "title": "No wagons",
            "description": "Measurements without wagons",
            "default": false
        },
        "manual_mode_allowed": {
            "type": "boolean",
            "title": "Manual mode allowed",
            "description": "Manual mode allowed",
            "default": true
        },
        "mode_file": {
            "type": "string",
            "title": "Manual mode file",
            "description": "Manual mode file name",
            "default": "mode.json"
        },
        "complex_filter": {
            "type": "boolean",
            "title": "Use alternative filter",
            "description": "PLC uses alternative filter parameters",
            "default": true
        },
        "edge_search_allowed": {
            "type": "boolean",
            "title": "Edge search allowed",
            "description": "Edge search allowed",
            "default": false
        },
        "slope_factor": {
            "type": "number",
            "title": "Slope factor",
            "description": "Slope factor for calculating slopes",
            "default": 2.0
        },
        "debug_mode_allowed": {
            "type": "boolean",
            "title": "Measuring debug mode allowed",
            "description": "Debug mode allowed for measuring",
            "default": false
        },
        "rotated_measurement_allowed": {
            "type": "boolean",
            "title": "Rotated measurement allowed",
            "description": "Rotated measurement allowed",
            "default": false
        },
        "measurement_points": {
            "type": "integer",
            "title": "Measurement point count",
            "description": "Measurement point count",
            "default": 200
        },
        "raw_measurement_points": {
            "type": "integer",
            "title": "Raw measurement point count",
            "description": "Raw measurement point count",
            "default": 1000
        },
        "center_add_points": {
            "type": "integer",
            "title": "Additional Px points",
            "description": "Use additional Px points in center line (P50, P100, P150, etc)",
            "default": 0
        },
        "hud_points": {
            "type": "integer",
            "title": "HUD points",
            "description": "HUD points",
            "default": 5
        },
        "adas_area_count": {
            "type": "integer",
            "title": "ADAS area count",
            "description": "ADAS area count",
            "default": 6
        },
        "angle_points": {
            "type": "integer",
             "title": "Angle points",
             "description": "Angle points",
             "default": 1
        },
        "yshift_offset": {
            "type": "integer",
            "title": "Yshift offset",
            "description": "Additional offset added to ynihe",
            "default": 763
        },
        "db_connection": {
            "type": "string",
            "title": "Database connection",
            "description": "Database connection string",
            "default": "Server=.;Database=klpms;User ID=klpms;Password=klpms"
        }
    },
    "order": [
        "conf_type",
        "debug",
        "dir_app",
        "dir_base",
        "dir_conf",
        "dir_data",
        "dir_products",
        "dir_measurements",
        "dir_nominalGraphs",
        "max_records",
        "user_password",
        "password",
        "session_file",
        "session_expiry",
        "conf_wagons",
        "conf_settings",
        "loading_wagon",
        "ads_net_id",
        "ads_port",
        "plc_cycle_time",
        "poll_cycle_time",
        "error_log",
        "error_log_lines",
        "logfile_web",
        "logfile_service",
        "log_level",
        "csv_number_format",
        "csv_encoding",
        "save_raw_measurements",
        "wagon_count",
        "wagon_offset_loading",
        "wagon_offset_bending",
        "measurement_line_count",
        "simple_ui",
        "glass_file_type",
        "no_wagons",
        "manual_mode_allowed",
        "mode_file",
        "complex_filter",
        "edge_search_allowed",
        "slope_factor",
        "debug_mode_allowed",
        "rotated_measurement_allowed",
        "measurement_points",
        "raw_measurement_points",
        "center_add_points",
        "hud_points",
        "adas_area_count",
        "yshift_offset",
        "db_connection"
    ]
}
